import Amplify from 'aws-amplify';
import config from '../aws-exports';

export function configureAmplify() {
  Amplify.configure({
    ...config,
    oauth: {
      ...config.oauth,
      redirectSignIn: 'https://portal.app.cleverday.com/oauth2/redirect/',
      redirectSignOut: 'https://portal.app.cleverday.com/oauth2/redirect/',
    },
    ssr: true,
  });
}
